t = require('app/scripts/views/internal/recup-with-helpers')('manage_members')

module.exports = t.statelessRenderable 'Member', ({ isSelected, member, toggleMember }) ->
  { avatarUrl, fullName, initials, id, username } = member

  disabled = member.joined

  onClick = -> if !disabled then toggleMember(id)
  onKeyUp = (e) -> if !disabled && (e.key == 'Enter' || e.key == ' ') then onClick()

  selectedClass = if isSelected then '.checked' else ''
  titleText = "#{fullName} (#{username})"

  t.div '.member-wrapper', {
    class: t.classify('disabled': disabled)
    tabIndex: 0
    onClick
    onKeyUp
  }, ->
    t.div '.member', ->
      if avatarUrl
        t.img '.member-avatar', {
          height: '32',
          width: '32',
          src: "#{ avatarUrl }/50.png"
          srcSet: "#{ avatarUrl }/50.png 1x, #{ avatarUrl }/50.png 2x"
          alt: titleText
          title: titleText
        }
      else if initials
        t.span '.member-initials', { title: titleText }, ->
          t.text initials
      else
        t.div '.member-icon-container', ->
          t.icon 'member'
    t.div '.full-name', -> t.text fullName
    t.div '.username.quiet', -> t.text '@' + username

    if !disabled
      t.div ".checkbox#{selectedClass}", ->
        t.span '.icon-lg.icon-check'
